export default "__VITE_ASSET__B7v7Gla7__"